import { render, staticRenderFns } from "./ProblemSection.vue?vue&type=template&id=a978d00c&scoped=true"
import script from "./ProblemSection.vue?vue&type=script&lang=js"
export * from "./ProblemSection.vue?vue&type=script&lang=js"
import style0 from "./ProblemSection.vue?vue&type=style&index=0&id=a978d00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a978d00c",
  null
  
)

export default component.exports